import React, { useState, useEffect } from "react";
import './Analytics.css';
import { Bar, Pie, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement
);

const Analytics = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {

    // const userToken = localStorage.getItem("userToken");  // Example token check
    const userToken = true;
    if (userToken) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const barData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Engagement",
        data: [50, 100, 150, 200, 180, 250],
        backgroundColor: "rgba(75, 192, 192, 0.3)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const pieData = {
    labels: ["Facebook", "Instagram", "Twitter", "LinkedIn"],
    datasets: [
      {
        data: [300, 400, 200, 150],
        backgroundColor: [
          "rgba(255, 99, 132, 0.3)",
          "rgba(54, 162, 235, 0.3)",
          "rgba(255, 206, 86, 0.3)",
          "rgba(75, 192, 192, 0.3)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const lineData = {
    labels: ["2019", "2020", "2021", "2022", "2023"],
    datasets: [
      {
        label: "Yearly Engagement Trend",
        data: [400, 500, 600, 700, 800],
        fill: false,
        borderColor: "rgba(75, 192, 192, 1)",
        tension: 0.2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "Engagement Analytics",
        font: {
          size: 20,
          weight: "bold",
        },
        color: "#333",
      },
      legend: {
        position: "top",
        labels: {
          font: {
            size: 14,
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  if (!isLoggedIn) {
    return (
      <div className="text-center ">
        <div className="alert alert-warning background-dark p-5" role="alert">
          <h4 className="alert-heading landing-text-white">You need to log in!</h4>
          <p className="landing-text-white"> Please log in to view your Analytics Dashboard.</p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-primary m-2" onClick={() => window.location.href = "/dashboard"}>
              Log in
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid bg-light py-3 background-dark">
      <h2 className="mb-3 ">Analytics Dashboard</h2>

      {/* First row with Pie and Line charts */}
      <div className="row ">
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="card p-4 shadow-lg border-0 rounded-lg hover-shadow">
            <h3 className="h5 font-weight-bold mb-4 text-warning ">Engagement Distribution</h3>
            <div className="analytical-graph">
              <Pie data={pieData} options={options} />
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-12 mb-4">
          <div className="card p-4 shadow-lg border-0 rounded-lg hover-shadow">
            <h3 className="h5 font-weight-bold mb-4 text-success">Yearly Engagement Trends</h3>
            <div className="analytical-graph" >
              <Line data={lineData} options={options} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-4">
          <div className="card p-4 shadow-lg border-0 rounded-lg hover-shadow">
            <h3 className="h5 font-weight-bold mb-4 text-info">Monthly Engagement Analytics</h3>
            <div className="analytical-graph" >
              <Bar data={barData} options={options} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
